<template>
	<b-modal
		hide-footer
		ref="modal-view"
		size="lg"
		:title="modelId ? 'Edición de Perfil' : 'Nuevo Perfil'"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>

		<b-form @submit="onSubmit">
			<b-form-row>
				<b-form-group :disabled="unableEdit" class="col-12" label="Nombre">
					<b-form-input
						type="text"
						size="sm"
						v-model="modelInfo.name"
						required
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group :disabled="unableEdit" class="col-12" label="Descripción">
					<b-form-textarea
						rows="5"
						type="text"
						size="sm"
						v-model="modelInfo.description"
						required
					/>
				</b-form-group>
			</b-form-row>

			<hr />
			<div class="text-right">
				<b-button :disabled="unableEdit" variant="primary" type="submit">{{
					modelId > 0 ? "Actualizar" : "Guardar"
				}}</b-button>
			</div>
		</b-form>
	</b-modal>
</template>

<script>
export default {
	props: {
		unableEdit: Boolean,
		successCallback: {
			type: Function,
			required: false,
			default: () => {}
		}
	},
	data() {
		return {
			modelId: null,
			loading: true,
			modelInfo: { ...this.modelInfoDefault },
			modelInfoDefault: {
				id: null,
				name: "",
				description: ""
			}
		};
	},
	methods: {
		onSubmit(event) {
			event.preventDefault();

			if (this.$listeners.submit) {
				this.$listeners.submit(event);
				return;
			}

			this.loading = true;

			let rParams = {
				url: this.modelId > 0 ? `/profiles/${this.modelId}` : "/profiles",
				method: this.modelId > 0 ? "put" : "post"
			};

			rParams["data"] = this.modelInfo;

			this.$root.api
				.request(rParams).then(res => {
					this.$root.showAlert(rParams.method == "post" ? "Perfil agregado con éxito" : "Perfil actualizado con éxito");

					if (res.data.id) this.loadModel(res.data.id);

					this.successCallback(res);
				}).catch(this.$root.handleRequestError).then(() => {
					this.loading = false;
				});
		},
		loadModel(id) {
			this.modelId = id;
			this.$refs["modal-view"].show();
			this.fetchModel();
		},
		fetchModel() {

			this.modelInfo = { ...this.modelInfoDefault }

			if (this.modelId) {
				// Cargar los datos del registro
				this.loading = true;
				this.$root.api
					.get(`/profiles/${this.modelId}`)
					.then(res => {
						this.$emit('update:unableEdit',!this.$hasPermission("profile.edit"))
						this.modelInfo = { ...res.data };
						this.loading = false;
					})
					.catch(this.$root.handleRequestError);
			} else {
				this.loading = false;
			}
		}
	},
};
</script>

<style></style>
